import useCache from '@/composables/useCache';
import { computed } from 'vue';
import { useStore } from '@/store';

export default function useItemsStore() {
  const store = useStore();

  const items = computed(() => store.state.items.items);
  const isLoadingItems = computed(() => store.state.items.loading);

  useCache('items/fetchItems');

  return {
    items,
    isLoadingItems,
  };
}
